var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXCircleOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13370",
    "data-name": "Group 13370",
    transform: "translate(-1482 -456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13233",
    "data-name": "Group 13233",
    transform: "translate(1482 455.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    transform: "translate(0 0.334)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.375,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13346",
    "data-name": "Group 13346",
    transform: "translate(1486.438 460.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13344",
    "data-name": "Group 13344",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_420-2",
    "data-name": "Ellipse 420",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(-0.438 -0.103)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13244",
    "data-name": "Group 13244",
    transform: "translate(6.046 6.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45469",
    "data-name": "Path 45469",
    d: "M14.018,0,8.642,6.338l5.87,8.526H10.193L6.31,9.218,6.2,9.135,1.259,14.864H0L5.668,8.272,0,0H4.27l3.8,5.481L12.809,0ZM12.735,13.975a2.286,2.286,0,0,0-.305-.509C9.58,9.262,6.569,5.162,3.677.988H1.728l9.107,12.987Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircleOrange);
export default __webpack_public_path__ + "static/media/X-circle-orange.aa5a59d7a80a07204884ee3d790beb55.svg";
export { ForwardRef as ReactComponent };